import React from 'react';
import "../testimonial.css";

const testimonials = [
    {
    name: "Sarah Mitchell",
    role: "Homeowner",
    text: "DLC Home Builders transformed our vision into reality. The attention to detail and professionalism throughout the process was exceptional. We couldn't be happier with our dream home!"
    },
    {
    name: "James Anderson",
    role: "Client",
    text: "From the first consultation to the final walkthrough, the team at DLC exceeded our expectations. The quality of work and commitment to our timeline was outstanding."
    },
    {
    name: "Emily Rodriguez",
    role: "Homeowner",
    text: "Building a custom home can be stressful, but DLC made the process smooth and enjoyable. Their expertise and guidance were invaluable. Highly recommend!"
    }
];

const TestimonialsSection = () => {
    return (
    <div className="page-wrapper">
      {/* Testimonials Section */}
        <section className="testimonials-container">
        <div className="section-header">
            <h2>Client Testimonials</h2>
            <p>Hear from homeowners who trusted us with their dreams</p>
        </div>

        <div className="testimonials-grid">
            {testimonials.map((t, index) => (
            <div key={index} className="testimonial-card">
                <div className="stars">★★★★★</div>
                <p className="testimonial-text">"{t.text}"</p>
                <div className="testimonial-footer">
                <strong>{t.name}</strong>
                <span>{t.role}</span>
                </div>
            </div>
            ))}
        </div>
        </section>

      {/* CTA Footer Section */}
        <section className="cta-section">
        <div className="cta-content">
            <h2>Ready to Build Your Dream Home?</h2>
            <p>Let's bring your vision to life. Contact us today for a free consultation.</p>
            <a href="/#dlc_form"><button className="cta-button">Schedule Consultation</button></a>
        </div>
        </section>
    </div>
    );
};

export default TestimonialsSection;